<template>
  <div>

    <!-- ── Navbar (solo se loggato) ───────────────── -->
    <nav class="dk-navbar" v-if="isLoggedIn">
      <router-link to="/dashboard" class="dk-navbar-brand">
        <img src="@/assets/img/deskalo_logo_definitivo_trasparente.png" alt="Deskalo" class="dk-navbar-logo">
      </router-link>

      <div class="dk-navbar-spacer"></div>

      <div class="dk-navbar-user" v-if="utente && utente.NOME">
        <span class="dk-navbar-user-name">{{utente.NOME}} {{utente.COGNOME}}</span>
        <div class="dropdown">
          <button class="dk-navbar-avatar" data-bs-toggle="dropdown" aria-expanded="false">
            {{getInitials()}}
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow">
            <li>
              <a class="dropdown-item" href="#" @click.prevent="modificaPassword()">
                <i class="fas fa-cogs fa-sm fa-fw me-2"></i> Modifica PIN
              </a>
            </li>
            <li v-if="isAdmin">
              <a class="dropdown-item" href="#" @click.prevent="configurazione()">
                <i class="fas fa-sliders-h fa-sm fa-fw me-2"></i> Configurazione
              </a>
            </li>
            <li v-if="isAdmin">
              <a class="dropdown-item" href="#" @click.prevent="utenti()">
                <i class="fas fa-users fa-sm fa-fw me-2"></i> Utenti
              </a>
            </li>
            <li><hr class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item text-danger" href="#" @click.prevent="logout()">
                <i class="fas fa-sign-out-alt fa-sm fa-fw me-2"></i> Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- ── Bottom Navigation mobile (solo se loggato) -->
    <bottom-nav v-if="isLoggedIn" @apri-profilo="modificaProfilo"></bottom-nav>

    <!-- ── Content ────────────────────────────────── -->
    <!-- Generato da claude — router-view nascosta finché startHandler() non ha verificato la sessione:
         evita il lampeggio della Dashboard (route di default '/') prima del redirect a Login -->
    <div :class="isLoggedIn ? 'dk-content' : ''" id="kt_vue_content_parent" v-if="!checkingAuth">
      <router-view/>
    </div>

    <!-- ══════════════════════════════════════════════
         MODALI GLOBALI
         ══════════════════════════════════════════════ -->

    <!-- Conferma azione -->
    <div class="modal fade" id="popUpConfirm" role="dialog" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-info">
            <h5 class="modal-title">{{alertConfirm.TITLE}}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Chiudi"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-2 pt-2" style="font-size:40px">
                <i class="fas" :class="alertConfirm.ICON"></i>
              </div>
              <div class="col-10 pt-2">
                <div v-html="alertConfirm.MESSAGE"></div>
              </div>
              <div class="col-12 mt-2" v-show="alertConfirm.MOSTRA_NOTE">
                <textarea class="form-control" v-model="alertConfirm.NOTE" placeholder="Note / richieste"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="alertConfirm.KOHandler()">
              <i class="fa fa-times fa-fw"></i> {{alertConfirm.KO}}
            </button>
            <button type="button" class="btn btn-success" @click="alertConfirm.OKHandler()">
              <i class="fa fa-check fa-fw"></i> {{alertConfirm.OK}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Alert standard -->
    <div class="modal fade" id="popUpAlertStandard" role="dialog" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-info">
            <h5 class="modal-title">{{alertStd.TITLE}}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Chiudi"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-2 pt-2" style="font-size:40px">
                <i :class="alertStd.ICON"></i>
              </div>
              <div class="col-10 pt-2">
                <div v-html="alertStd.MESSAGE"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" @click="alertStd.OKHandler()">
              <i class="fa fa-check fa-fw"></i> {{alertStd.OK}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modifica PIN -->
    <div class="modal fade" id="popUpModificaPassword" role="dialog" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-info">
            <h5 class="modal-title">Modifica PIN</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Chiudi"></button>
          </div>
          <div class="modal-body">
            <form autocomplete="off">
              <div class="mb-3">
                <label class="form-label">Vecchio PIN</label>
                <input class="form-control" autocomplete="off" placeholder="5 cifre" type="password" inputmode="numeric" maxlength="5" v-model="passwordUtente.VECCHIA_PASSWORD">
              </div>
              <div class="mb-3">
                <label class="form-label">Nuovo PIN</label>
                <input class="form-control" autocomplete="off" placeholder="5 cifre numeriche" type="password" inputmode="numeric" maxlength="5" v-model="passwordUtente.PASSWORD">
              </div>
              <div class="mb-3">
                <label class="form-label">Conferma nuovo PIN</label>
                <input class="form-control" autocomplete="off" placeholder="5 cifre numeriche" type="password" inputmode="numeric" maxlength="5" v-model="passwordUtente.CONFERMA_PASSWORD">
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
              <i class="fa fa-times fa-fw"></i> Annulla
            </button>
            <button type="button" class="btn btn-success" @click="doModificaPassword()">
              <i class="fa fa-check fa-fw"></i> Salva
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import BottomNav from '@/components/common/BottomNav.vue'

export default {
    name: 'App',
    components: { BottomNav },
    data: function() {
        return {
            alertConfirm: { MESSAGE: '', NOTE: '' },
            alertStd: {},
            zindex: 1100,
            passwordUtente: {},
            isAdmin: false,
            utente: {},
            arrayStagioni: [],
            idStagioneCorrente: 0,
            previousRoute: '/',
            arrayNegozi: [],
            VERSIONE: '',
            // Generato da claude — true finché startHandler() non ha verificato la sessione
            checkingAuth: true,
            DESKALO_SOCIO_SELEZIONATO: {},
            SOCIETA_SPECIFICA: {},
            homeStats: {},
        }
    },
    computed: {
        isLoggedIn() {
            return !!(this.utente && this.utente.NOME);
        },
        currentRouteName() {
            return this.$route.path;
        },
    },
    methods: {
        getInitials() {
            const n = (this.utente.NOME || '')[0] || '';
            const c = (this.utente.COGNOME || '')[0] || '';
            return (n + c).toUpperCase() || '?';
        },
        logout() {
            global.utils.ajax('core/logout', {}, () => {
                this.utente = {};
                this.homeStats = {};
                global.utils.deleteCookie('session_token');
                global.router.push('Login');
            });
        },
        confirm(alertConfirm) {
            this.alertConfirm = alertConfirm;
            global.$('#popUpConfirm').modal('show');
        },
        modificaPassword() {
            global.$('#popUpModificaPassword').modal('show');
        },
        // Generato da claude — Deskalo 2: cambio PIN con validazione 5 cifre numeriche
        isPinTroppoFacile(pin) {
            if (/^(\d)\1{4}$/.test(pin)) return true; // tutte uguali: 11111, 22222
            const d = pin.split('').map(Number);
            const crescente   = d.every((n, i) => i === 0 || n === d[i-1] + 1);
            const decrescente = d.every((n, i) => i === 0 || n === d[i-1] - 1);
            return crescente || decrescente;
        },
        doModificaPassword() {
            const pin      = (this.passwordUtente.PASSWORD         || '').trim();
            const conferma = (this.passwordUtente.CONFERMA_PASSWORD || '').trim();
            if (!/^\d{5}$/.test(pin)) {
                alert('Il PIN deve essere composto da esattamente 5 cifre numeriche');
                return;
            }
            if (this.isPinTroppoFacile(pin)) {
                alert('Il PIN scelto è troppo semplice (es. 12345, 11111). Scegli un PIN più sicuro.');
                return;
            }
            if (pin !== conferma) {
                alert('Il nuovo PIN e la conferma non coincidono');
                return;
            }
            global.$('#popUpModificaPassword').modal('hide');
            global.utils.ajax('deskalo/socio/pin/update', this.passwordUtente, (response) => {
                if (response.esito == 0) {
                    global.utils.alert.success('PIN aggiornato correttamente');
                    this.passwordUtente = {};
                }
            });
        },
        modificaProfilo() {
            global.router.push('Profilo');
        },
        configurazione() {
            global.router.push('configurazione');
        },
        utenti() {
            global.router.push('utenti');
        },
        back() {
            global.router.go(-1);
        },
        setHeader(_title, _icon) {
            // mantenuto per retrocompatibilità con view che chiamano global.utils.setHeader
        },
        getSocio() {
            return this.utente || {};
        },
        getNegozio(idNegozio) {
            for (var i = 0; i < this.arrayNegozi.length; i++) {
                if (this.arrayNegozi[i].ID_NEGOZIO == idNegozio) return this.arrayNegozi[i];
            }
            return {};
        },
        getImgHeader() {
            if (this.SOCIETA_SPECIFICA && this.SOCIETA_SPECIFICA.ID_SOCIETA > 0) {
                return 'https://gestionale.assosprint.it/CORE/SERVER/UPLOAD/IMG/LOGHI/' + this.SOCIETA_SPECIFICA.LOGO;
            }
            return 'https://deskalo.it/deskalo.png';
        },
        // Generato da claude — Deskalo 2: usa deskalo/logged, nessuna selezione socio
        startHandler() {
            var token = global.utils.getCookie('session_token');
            if (token && token !== 'undefined') {
                global.utils.SESSION_TOKEN = token;
                global.utils.ajax('deskalo/logged', {}, (response) => {
                    if (response.esito == 0 && response.data.SOCIO && response.data.SOCIO.ID_SOCIO > 0) {
                        this.utente = response.data.SOCIO.personaFisica;
                        this.DESKALO_SOCIO_SELEZIONATO = response.data.DESKALO_SOCIO_SELEZIONATO || {};
                        global.router.push('Dashboard');
                    } else {
                        global.utils.setCookie('session_token', '');
                        global.router.push('Login');
                    }
                    this.checkingAuth = false;
                }, true, 1);
            } else {
                global.router.push('Login');
                this.checkingAuth = false;
            }
        },
        setSocieta(handler = null) {
            if (typeof societa_specifica !== 'undefined') {
                const skip = ['Login', 'Dashboard', 'Prenotazioni', 'Abbonamenti', 'Richieste', 'Anagrafica', 'Ricevute', 'Utenti', 0, undefined, ''];
                if (societa_specifica && !skip.includes(societa_specifica)) {
                    utils.ajax('deskalo/societaspecifica/set', { SOCIETA_SPECIFICA: societa_specifica }, (response) => {
                        if (response.esito == 0) {
                            this.SOCIETA_SPECIFICA = response.data;
                            if (handler) handler();
                        }
                    });
                    return;
                }
            }
            if (handler) handler();
        },
    },
    created() {
        const ua = navigator.userAgent;
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
        global.utils.IS_MOBILE = this.isMobile;
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.VERSIONE = process.env.VUE_APP_VERSION_NUMBER;

        setTimeout(() => {
            $('.modal').on('show.bs.modal', () => {
                setTimeout(() => {
                    this.zindex++;
                    $('.modal-backdrop').last().css('z-index', this.zindex);
                    this.zindex++;
                    $('.modal.fade.show').last().css('z-index', this.zindex);
                }, 200);
            });
        }, 400);

        this.setSocieta();
        setTimeout(() => { this.startHandler(); }, 400);
    },
    watch: {
        $route(to, from) {
            this.previousRoute = from.path;
            $('#kt_vue_content_parent').hide().fadeIn(600);
            setTimeout(() => {
                global.$('form').submit(function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                });
                global.utils.resizeContent();
            }, 300);
        }
    }
}
</script>
